export function richTextToString(blocks: any) {
    if (!blocks || !Array.isArray(blocks)) return '';

    return blocks
        .map((block) => {
            // If the block contains inline text children (like paragraphs, headings, lists)
            if (block.children) {
                return block.children.map((child: any) => child.text || '').join('');
            }
            // If it's a code block or has raw text directly
            if (block.type === 'code' && block.plainText) {
                return block.plainText;
            }
            return '';
        })
        .join('\n'); // Joins blocks with line breaks
}
